<template>
  <div class="w-full max-w-7xl flex flex-col gap-6">
    <div
      v-for="i in times"
      :key="`skeleton-${i}`"
      class="w-full rounded-lg animate-pulse"
    >
      <!-- Header -->
      <div class="w-2/3 h-4 bg-gray-300/50 rounded mb-2"></div>

      <!-- Body -->
      <div class="w-full h-8 bg-gray-300/50 rounded mb-2"></div>
      <div class="w-full h-8 bg-gray-300/50 rounded mb-2"></div>
      <div class="w-1/2 h-8 bg-gray-300/50 rounded"></div>
    </div>
  </div>
</template>

<script setup>
  defineOptions({
    name: "SkeletonLoader",
  })

  defineProps({
    times: {
      type: Number,
      default: 3,
    },
  })
</script>
